import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchFxRatesLatest } from './client.js';
import { setActiveFxRates } from '../currency.js';

// Pulls latest-spot FX from /fx-rates/latest and overlays it onto the display
// converters (currency.ts). Mount once near the root. Server-side the rates
// refresh weekly, so we cache long. On failure the bundled fallback rates stay
// in effect — display never blocks on FX.
//
// The setApplied bump forces one re-render AFTER the module rates are updated,
// so every monetary value on screen re-converts at the live rate (the converters
// are pure module functions React can't otherwise know changed).
export function useFxRatesSync(): void {
  const [, setApplied] = useState(0);
  const q = useQuery({
    queryKey: ['fx-rates-latest'],
    queryFn: fetchFxRatesLatest,
    staleTime: 6 * 60 * 60 * 1000, // 6h — rates only move weekly server-side
    gcTime: 24 * 60 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
  });
  useEffect(() => {
    if (q.data?.rates) {
      setActiveFxRates(q.data.rates);
      setApplied((n) => n + 1);
    }
  }, [q.data]);
}
